import api from './api';

const affiliationService = {
  async list({ activeOnly = true } = {}) {
    const response = await api.get('/smie-affiliations', {
      params: { active_only: activeOnly ? 'true' : 'false' }
    });
    return response;
  },

  async create(payload) {
    return api.post('/smie-affiliations', payload);
  }
};

export default affiliationService;
